import { ChangeDetectionStrategy, Component, HostBinding, effect, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-json-ld',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class JsonLdComponent {
  private sanitizer = inject(DomSanitizer);

  json = input<any>({});

  @HostBinding('innerHTML') jsonLD?: SafeHtml;

  constructor() {
    effect(() => {
      const js = this.json();
      this.jsonLD = this.getSafeHTML(js);
    });
  }

  getSafeHTML(value: {}) {
    const json = value ? JSON.stringify(value).replace(/<\/script>/g, '<\\/script>') : '';
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
